<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text>
        <v-flex xs12 sm6 md12>
          <v-text-field :loading="loading.plan" label="Name" v-model="itemData.name"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field
            :loading="loading.plan"
            label="Price"
            prefix="$"
            v-model="itemData.price"
            :suffix="selectedCasket ? '(includes casket price $ ' + casketById(selectedCasket).price + ')' : ''"
          >
          </v-text-field>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-select
            :items="allCaskets"
            :loading="loading.plan"
            v-model="selectedCasket"
            clearable
            label="Select Casket Model"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-combobox
            :items="products"
            :loading="loading.plan"
            v-model="selectedServices"
            hide-selected
            multiple
            persistent-hint
            small-chips
            label="Select Products">
          </v-combobox>
        </v-flex>


        <v-data-table
          v-if="selectedServices && selectedServices.length"
          :items="selectedServices"
          :headers="productsTableHeaders"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td class="quantity_bgcolor">
              <v-edit-dialog
                :return-value.sync="props.item.amount"
                large
                lazy
                persistent
              >
                <div>{{ props.item.amount }}</div>
                <template v-slot:input>
                  <div class="mt-3 title">Update Amount</div>
                </template>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.amount"
                    label="Quantity"
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td>${{ props.item.price }}</td>
            <td>${{ props.item.amount * props.item.price }}</td>
          </template>
        </v-data-table>
        <!--
        <div><span v-if="totalPrice > 0"><b>Total price<sup>*</sup>: ${{ totalPrice || 0 }}</b></span></div>
        <div><sup>*</sup><i>total price doesn't include plan price, it's a sum of product prices.</i></div>
        -->
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="showAlert"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="flex-alert-center">
          <v-icon dark right class="flex-alert-notification-check">error</v-icon> {{ alertMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    mixins: [ dialogMixins ],
    data () {
      return {
        resource: 'plans',
        selectedServices: [],
        productsTableHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Qty', value: 'amount', width: '5px' },
          { text: 'Unit', value: 'price' },
          { text: 'Subtotal', value: 'price' }
        ],
        selectedCasket: null,
        loading: {
          plan: false
        },
        showAlert: false,
        alertMessage: null
      }
    },
    computed: {
      ...mapGetters({
        products: 'allProducts',
        serviceById: 'getProductById',
        plans: 'allPlans',
        planById: 'getPlanById',
        allCaskets: 'allCaskets',
        casketById: 'getCasketById',
        filterFromLinkedServices: 'filterFromLinkedServices',
        filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
        removeCasketsFromServices: 'removeCasketsFromServices'
      }),
      totalPrice () {
        if (!this.planById(this.itemId) && !this.selectedCasket && !this.selectedServices) return false
        /*
        return (this.planById(this.itemId) ? parseFloat(this.itemData.price) : 0) +
          (this.casketById(this.selectedCasket) ? parseFloat(this.casketById(this.selectedCasket).price) : 0) +
          (this.selectedServices ? _.reduce(this.selectedServices, (sum, p) => {
            return sum + parseFloat(p.price) * p.amount
          }, 0) : 0)
        */
        return this.selectedServices ? _.reduce(this.selectedServices, (sum, p) => {
          return sum + parseFloat(p.price) * p.amount
        }, 0) : 0
      }
    },
    methods: {
      editItemDataDecorator () {
        if (!this.checkQuantity()) {
          this.alertMessage = 'Please set quantity'
          this.showAlert = true
          setTimeout(() => {
            this.showAlert = false
          }, 2000)
          return
        }
        let selectedServices = this.selectedServices
        if (this.selectedCasket) selectedServices.push(this.casketById(this.selectedCasket))
        this.itemData.services = selectedServices

        this.editItemData()
        this.$bus.$emit('resource-updated')
        this.$store.dispatch('getAllPlans')
        this.selectedServices = this.removeCasketsFromServices(this.itemData.services)
      },
      checkQuantity () {
        let check = true
        this.selectedServices.forEach(item => {
          if (!item.amount) check = false
        })
        return check
      }
    },
    watch: {
      itemId () {
        if (this.itemId > 0) {
          this.selectedCasket = this.filterCasketFromLinkedProducts(this.planById(this.itemId).services)
          this.selectedServices = this.filterFromLinkedServices(this.planById(this.itemId).services)
        }
      }
    },
    beforeCreate () {
      this.$store.dispatch('getAllPlans')
      this.$store.dispatch('getAllProducts')
    },
    created () {}
  }
</script>



// WEBPACK FOOTER //
// AppEditPlansDialog.vue?5b1138b5